import React from 'react'

import Link from 'next/link'
import { Button } from 'antd'
import classnames from 'classnames'

import styles from './InsufficientStatus.module.scss'

export default React.memo(function InsufficientStatus({ onCheckFunds, tip, children, status, className }) {
  if (status === 'DONE_WITH_NOT_SUFFICIENT_FUNDS') {
    return (
      <div className={styles.container}>
        <div className={styles.error}>
          {tip}
          <Button type="link" size="small">
            <Link href="/pricing">前往充值</Link>
          </Button>
          <Button type="link" size="small" onClick={onCheckFunds}>我已充值</Button>
        </div>
      </div>
    )
  }

  return children
})
